export const CLEAR_SEARCH = "UI/HEADER/TEAM_MENU/CLEAR_SEARCH";
export const CLEAR_ALL = "UI/HEADER/TEAM_MENU/CLEAR_ALL";
export const NAVIGATE_DOWN = "UI/HEADER/TEAM_MENU/NAVIGATE_DOWN";
export const NAVIGATE_UP = "UI/HEADER/TEAM_MENU/NAVIGATE_UP";
export const SEARCH_TEAMS = "UI/HEADER/TEAM_MENU/SEARCH_TEAMS";
export const SEARCH_TEAMS_SUCCESS = "UI/HEADER/TEAM_MENU/SEARCH_TEAMS_SUCCESS";
export const SWITCH_TEAMS = "UI/HEADER/TEAM_MENU/SWITCH_TEAMS";
